import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import * as THREE from 'three';

export function loadObj(url: string, onloaded: (obj: THREE.Group) => void) {
    const loader = new OBJLoader();
    loader.load(url, (obj) => {
        onloaded(obj);
    });
}

